import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';

import { DEMO_FORMS } from '../form-registry';

@Component({
  selector: 'app-form-overview',
  imports: [
    RouterLink,
    MatButtonModule
  ],
  templateUrl: './form-overview.component.html',
  styleUrl: './form-overview.component.scss'
})
export class FormOverviewComponent {

  readonly forms = DEMO_FORMS;
}
